export function Support() {
  return (
    <div className="max-w-xl">
      <pre className="mb-4 whitespace-pre-wrap text-sm">
        {`this terminal is free. no fees, no token, no telemetry.
no wallet connection. no signing. no transaction submission.

hosted services supply read-only Avalanche and Robinhood evidence.
unavailable or degraded signals are never presented as clean.`}
      </pre>
      <p className="text-xs" style={{ color: "var(--flurry-mid)" }}>
        source on github · issues and PRs welcome
      </p>
    </div>
  );
}
